import React, { useEffect } from "react";
import { ProfileIcon } from "components/SVG";
import { profileButton } from "./ProfileButton.css";
import {
  basketCounter,
  basketIconContainer,
  counterContainer
} from "../../BasketCount/style.css";
import { useRouter } from "../../../../lib/router";
import { useUser } from "../../../../lib/user";

type Props = {
  onClick: () => void;
  showNotification?: boolean;
};

export const ProfileButton: React.FC<Props> = ({
  onClick,
  showNotification
}) => {
  const [notificationClicked, setNotificationClicked] =
    React.useState<boolean>(true);
  const router = useRouter();

  const isOrderItAgainPage = router.pathname.includes(
    "/account/favourites/order-it-again"
  );

  const { isMember } = useUser();

  useEffect(() => {
    setNotificationClicked(!!localStorage.getItem("HIGHLIGHTED_NAV_ITEM"));
  }, []);

  return (
    <button
      role="menuitem"
      aria-label="Toggle account menu"
      type="button"
      className={profileButton}
      data-testid="profile-button"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <div className={basketIconContainer}>
        {showNotification &&
          !notificationClicked &&
          !isOrderItAgainPage &&
          isMember && (
            <>
              <div className={counterContainer}>
                <span
                  className={basketCounter}
                  style={{
                    color: "white",
                    fontSize: "0.5rem"
                  }}
                  data-testid="basket-count"
                  aria-label="Basket Count"
                >
                  1
                </span>
              </div>
            </>
          )}
        <ProfileIcon />
      </div>
      <p>Profile</p>
    </button>
  );
};
